
import { useAttendanceNotifications, useMeetingNotifications } from "../../hooks/useNotificationHooks";


/**
 * Component to manage all notification triggers
 * Should be placed near the top of the app hierarchy
 */
export default function NotificationManager() {
    // Activate all notification hooks
    useAttendanceNotifications();
    useMeetingNotifications();

    return null; // This component doesn't render anything
}
